import { useEffect, useState } from "react";
import { ThumbsDown, ThumbsUp } from "lucide-react";
import { Card } from "@/pages/admin/AdminPeople";
import { api, fmtDate } from "@/lib/api";

export function CoachInsights() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/coach").then((r) => setD(r.data)); }, []);
  if (!d) return null;
  return (
    <div className="grid lg:grid-cols-[1.3fr_1fr] gap-6" data-testid="admin-coach">
      <Card className="space-y-4">
        <h2 className="font-bold text-slate-900">Rated answers</h2>
        {!d.feedback.length && <p className="text-sm text-slate-500">No ratings yet.</p>}
        {d.feedback.map((f, i) => (
          <div key={i} className="border-t border-slate-100 pt-3 space-y-1.5 text-sm" data-testid={`coach-feedback-${i}`}>
            <div className="flex items-center gap-2 text-xs text-slate-500">
              {f.rating === 1 ? <ThumbsUp className="h-4 w-4 text-teal-600" /> : <ThumbsDown className="h-4 w-4 text-rose-600" />}
              {f.email} · {f.module_slug || "dashboard"} · {fmtDate(f.rated_at)}
            </div>
            <p className="font-medium text-slate-800">Q: {f.question}</p>
            <p className="text-slate-600 line-clamp-4 whitespace-pre-wrap">A: {f.answer}</p>
          </div>
        ))}
      </Card>
      <div className="space-y-6">
        <Card>
          <h2 className="font-bold text-slate-900 mb-3">Common topics</h2>
          <div className="flex flex-wrap gap-2">{d.top_terms.map(([t, c]) => <span key={t} className="text-xs px-2.5 py-1 rounded-full bg-teal-50 text-teal-900 border border-teal-100">{t} · {c}</span>)}</div>
          <h3 className="font-semibold text-sm mt-5 mb-2">Questions by page</h3>
          <ul className="text-sm text-slate-600 space-y-1">{d.by_module.map(([m, c]) => <li key={m}>{m}: {c}</li>)}</ul>
        </Card>
        <Card>
          <h2 className="font-bold text-slate-900 mb-3">Recent questions</h2>
          <ul className="space-y-2 text-sm text-slate-700 max-h-96 overflow-y-auto">{d.recent_questions.map((q, i) => <li key={i} className="border-b border-slate-100 pb-2">{q.question}</li>)}</ul>
        </Card>
      </div>
    </div>
  );
}
